import { defineStore } from 'pinia'
import { getCityList } from "@/api/service";
import { flattenTree } from "@/util/common";

export const useUserStore = defineStore('user', {
  state: () => ({
    token: '',
    userInfo: null,
    activeRoleValue: null,
    permissions: [],
    routes: [],
    cityList: null,
    flatCityList: null,
    currentImUserSn: null,
    currentRoomId: null,
    totalUnreadCount: 0,
    wsData: null,
    chatOrderId: null,
    chatPeerUserType: null
  }),
  actions: {
    ///初始化城市列表
    async initCityList () {
      await getCityList().then(res => {
        let cityArr = res.data || [];
        this.cityList = cityArr;   
        this.flatCityList = flattenTree(cityArr);
      });
    },
    ///获取城市列表
    async getCityList() {
      let hasCityList = this.cityList !== null
      if(!hasCityList) {
        await this.initCityList()
      }
      return {
        cityList: this.cityList || [],
        flatCityList: this.flatCityList || []
      }
    },
    setToken(token) {
      this.token = token
    },
    setUserInfo(userInfo) {
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
      this.userInfo = userInfo;      
      this.activeRoleValue = userInfo?.activeRoleValue || userInfo?.userType || null
      localStorage.setItem('activeRoleValue', this.activeRoleValue)
    },
    getActiveRoleValue() {      
      return this.activeRoleValue || Number(localStorage.getItem('activeRoleValue'))
    },
    getUserInfo() {
      return this.userInfo || JSON.parse(localStorage.getItem('userInfo')||'{}')
    },
    setPermissions(permissions) {
      this.permissions = permissions
    },
    getPermissions() {
      console.log('getPermissions', this.permissions );
      return this.permissions || []
    },
    setRoutes(routes) {
      this.routes = routes
    },
    setCurrentImUserSn(currentImUserSn) {
      this.currentImUserSn = currentImUserSn
    },
    setTotalUnreadCount(totalUnreadCount) {
      this.totalUnreadCount = totalUnreadCount
    },
    setCurrentRoomId(currentRoomId) {
      this.currentRoomId = currentRoomId
    },
    setWsData(data) {
      this.wsData = data
    },
    getWsData() {
      console.log('getWsData', this.wsData );
      return this.wsData || null
    },
    getCurrentImUserSn() {
      return this.currentImUserSn || null
    },
    getCurrentRoomId() {
      return this.currentRoomId || null
    },
    getTotalUnreadCount() {
      return this.totalUnreadCount || 0
    },
    setChatInfo(orderId, peerUserType) {
      this.chatOrderId = orderId
      this.chatPeerUserType = peerUserType
    },
    getChatInfo() {
      return {
        orderId: this.chatOrderId,
        peerUserType: this.chatPeerUserType
      }
    },
    clearChatInfo() {
      this.chatOrderId = null
      this.chatPeerUserType = null
    },
    logout() {
      this.token = ''
      this.userInfo = null
      this.permissions = []
      this.routes = []
      localStorage.removeItem('userInfo')
      localStorage.removeItem('X-Access-Token')
    }
  }
})